import _slicedToArray from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/matteo/Projects/GitHub/tsparticles/gatsby-landing-page-starter/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __classPrivateFieldSet = this && this.__classPrivateFieldSet || function (receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};

var __classPrivateFieldGet = this && this.__classPrivateFieldGet || function (receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};

var _Particle_engine;

import { calcExactPositionOrRandomFromSize, clamp, getDistance, getParticleBaseVelocity, getParticleDirectionAngle, getRangeMax, getRangeMin, getRangeValue, getValue, randomInRange, setRangeValue } from "../Utils/NumberUtils";
import { deepExtend, isInArray, itemFromArray } from "../Utils/Utils";
import { getHslFromAnimation, rangeColorToRgb } from "../Utils/ColorUtils";
import { Interactivity } from "../Options/Classes/Interactivity/Interactivity";
import { Shape } from "../Options/Classes/Particles/Shape/Shape";
import { Vector } from "./Utils/Vector";
import { Vector3d } from "./Utils/Vector3d";
import { alterHsl } from "../Utils/CanvasUtils";
import { loadParticlesOptions } from "../Utils/OptionsUtils";

var fixOutMode = function fixOutMode(data) {
  if (!(isInArray(data.outMode, data.checkModes) || isInArray(data.outMode, data.checkModes))) {
    return;
  }

  if (data.coord > data.maxCoord - data.radius * 2) {
    data.setCb(-data.radius);
  } else if (data.coord < data.radius * 2) {
    data.setCb(data.radius);
  }
};

export var Particle = /*#__PURE__*/function () {
  function Particle(engine, id, container, position, overrideOptions, group) {
    _classCallCheck(this, Particle);

    var _a, _b, _c, _d, _e, _f;

    this.id = id;
    this.container = container;
    this.group = group;

    _Particle_engine.set(this, void 0);

    __classPrivateFieldSet(this, _Particle_engine, engine, "f");

    this.fill = true;
    this.close = true;
    this.lastPathTime = 0;
    this.destroyed = false;
    this.unbreakable = false;
    this.splitCount = 0;
    this.misplaced = false;
    this.retina = {
      maxDistance: {}
    };
    this.outType = "normal";
    this.ignoresResizeRatio = true;
    var pxRatio = container.retina.pixelRatio,
        mainOptions = container.actualOptions,
        particlesOptions = loadParticlesOptions(__classPrivateFieldGet(this, _Particle_engine, "f"), container, mainOptions.particles);
    var shapeType = particlesOptions.shape.type,
        reduceDuplicates = particlesOptions.reduceDuplicates;
    this.shape = shapeType instanceof Array ? itemFromArray(shapeType, this.id, reduceDuplicates) : shapeType;

    if (overrideOptions === null || overrideOptions === void 0 ? void 0 : overrideOptions.shape) {
      if (overrideOptions.shape.type) {
        var overrideShapeType = overrideOptions.shape.type;
        this.shape = overrideShapeType instanceof Array ? itemFromArray(overrideShapeType, this.id, reduceDuplicates) : overrideShapeType;
      }

      var shapeOptions = new Shape();
      shapeOptions.load(overrideOptions.shape);

      if (this.shape) {
        this.shapeData = this.loadShapeData(shapeOptions, reduceDuplicates);
      }
    } else {
      this.shapeData = this.loadShapeData(particlesOptions.shape, reduceDuplicates);
    }

    particlesOptions.load(overrideOptions);
    particlesOptions.load((_a = this.shapeData) === null || _a === void 0 ? void 0 : _a.particles);
    this.interactivity = new Interactivity();
    this.interactivity.load(container.actualOptions.interactivity);
    this.interactivity.load(particlesOptions.interactivity);
    this.fill = (_c = (_b = this.shapeData) === null || _b === void 0 ? void 0 : _b.fill) !== null && _c !== void 0 ? _c : this.fill;
    this.close = (_e = (_d = this.shapeData) === null || _d === void 0 ? void 0 : _d.close) !== null && _e !== void 0 ? _e : this.close;
    this.options = particlesOptions;
    this.pathDelay = getValue(this.options.move.path.delay) * 1000;
    var zIndexValue = getRangeValue(this.options.zIndex.value);
    container.retina.initParticle(this);
    var sizeOptions = this.options.size,
        sizeRange = sizeOptions.value,
        sizeAnimation = sizeOptions.animation;
    this.size = {
      enable: sizeOptions.animation.enable,
      value: getRangeValue(sizeOptions.value) * container.retina.pixelRatio,
      max: getRangeMax(sizeRange) * pxRatio,
      min: getRangeMin(sizeRange) * pxRatio,
      loops: 0,
      maxLoops: getRangeValue(sizeOptions.animation.count)
    };

    if (sizeAnimation.enable) {
      this.size.status = 0;
      this.size.decay = 1 - getRangeValue(sizeAnimation.decay);

      switch (sizeAnimation.startValue) {
        case "min":
          this.size.value = this.size.min;
          this.size.status = 0;
          break;

        case "random":
          this.size.value = randomInRange(this.size) * pxRatio;
          this.size.status = Math.random() >= 0.5 ? 0 : 1;
          break;

        case "max":
        default:
          this.size.value = this.size.max;
          this.size.status = 1;
          break;
      }

      this.size.velocity = ((_f = this.retina.sizeAnimationSpeed) !== null && _f !== void 0 ? _f : container.retina.sizeAnimationSpeed) / 100 * container.retina.reduceFactor;

      if (!sizeAnimation.sync) {
        this.size.velocity *= Math.random();
      }
    }

    this.bubble = {
      inRange: false
    };
    this.position = this.calcPosition(container, position, clamp(zIndexValue, 0, container.zLayers));
    this.initialPosition = this.position.copy();
    var canvasSize = container.canvas.size,
        moveCenterPerc = this.options.move.center;
    this.moveCenter = {
      x: canvasSize.width * moveCenterPerc.x / 100,
      y: canvasSize.height * moveCenterPerc.y / 100,
      radius: this.options.move.center.radius
    };
    this.direction = getParticleDirectionAngle(this.options.move.direction, this.position, this.moveCenter);

    switch (this.options.move.direction) {
      case "inside":
        this.outType = "inside";
        break;

      case "outside":
        this.outType = "outside";
        break;
    }

    this.initialVelocity = this.calculateVelocity();
    this.velocity = this.initialVelocity.copy();
    this.moveDecay = 1 - getRangeValue(this.options.move.decay);
    this.offset = Vector.origin;
    var particles = container.particles;
    particles.needsSort = particles.needsSort || particles.lastZIndex < this.position.z;
    particles.lastZIndex = this.position.z;
    this.zIndexFactor = this.position.z / container.zLayers;
    this.sides = 24;
    var drawer = container.drawers.get(this.shape);

    if (!drawer) {
      drawer = __classPrivateFieldGet(this, _Particle_engine, "f").plugins.getShapeDrawer(this.shape);

      if (drawer) {
        container.drawers.set(this.shape, drawer);
      }
    }

    if (drawer === null || drawer === void 0 ? void 0 : drawer.loadShape) {
      drawer === null || drawer === void 0 ? void 0 : drawer.loadShape(this);
    }

    var sideCountFunc = drawer === null || drawer === void 0 ? void 0 : drawer.getSidesCount;

    if (sideCountFunc) {
      this.sides = sideCountFunc(this);
    }

    this.spawning = false;
    this.shadowColor = rangeColorToRgb(this.options.shadow.color);

    var _iterator = _createForOfIteratorHelper(container.particles.updaters),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var updater = _step.value;

        if (updater.init) {
          updater.init(this);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(container.particles.movers),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var mover = _step2.value;

        if (mover.init) {
          mover.init(this);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    if (drawer && drawer.particleInit) {
      drawer.particleInit(container, this);
    }

    var _iterator3 = _createForOfIteratorHelper(container.plugins),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _step3$value = _slicedToArray(_step3.value, 2),
            plugin = _step3$value[1];

        if (plugin.particleCreated) {
          plugin.particleCreated(this);
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  _createClass(Particle, [{
    key: "destroy",
    value: function destroy(override) {
      if (this.unbreakable || this.destroyed) {
        return;
      }

      this.destroyed = true;
      this.bubble.inRange = false;

      var _iterator4 = _createForOfIteratorHelper(this.container.plugins),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _step4$value = _slicedToArray(_step4.value, 2),
              plugin = _step4$value[1];

          if (plugin.particleDestroyed) {
            plugin.particleDestroyed(this, override);
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (override) {
        return;
      }

      var destroyOptions = this.options.destroy;

      if (destroyOptions.mode === "split") {
        this.split();
      }
    }
  }, {
    key: "draw",
    value: function draw(delta) {
      var container = this.container;

      var _iterator5 = _createForOfIteratorHelper(container.plugins),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              plugin = _step5$value[1];

          container.canvas.drawParticlePlugin(plugin, this, delta);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      container.canvas.drawParticle(this, delta);
    }
  }, {
    key: "getFillColor",
    value: function getFillColor() {
      var _a, _b;

      var color = (_a = this.bubble.color) !== null && _a !== void 0 ? _a : getHslFromAnimation(this.color);

      if (color && this.roll && (this.backColor || this.roll.alter)) {
        var backFactor = this.roll.horizontal && this.roll.vertical ? 2 : 1,
            backSum = this.roll.horizontal ? Math.PI / 2 : 0,
            rolled = Math.floor((((_b = this.roll.angle) !== null && _b !== void 0 ? _b : 0) + backSum) / (Math.PI / backFactor)) % 2;

        if (rolled) {
          if (this.backColor) {
            return this.backColor;
          }

          if (this.roll.alter) {
            return alterHsl(color, this.roll.alter.type, this.roll.alter.value);
          }
        }
      }

      return color;
    }
  }, {
    key: "getMass",
    value: function getMass() {
      return Math.pow(this.getRadius(), 2) * Math.PI / 2;
    }
  }, {
    key: "getPosition",
    value: function getPosition() {
      return {
        x: this.position.x + this.offset.x,
        y: this.position.y + this.offset.y,
        z: this.position.z
      };
    }
  }, {
    key: "getRadius",
    value: function getRadius() {
      var _a;

      return (_a = this.bubble.radius) !== null && _a !== void 0 ? _a : this.size.value;
    }
  }, {
    key: "getStrokeColor",
    value: function getStrokeColor() {
      var _a, _b;

      return (_b = (_a = this.bubble.color) !== null && _a !== void 0 ? _a : getHslFromAnimation(this.strokeColor)) !== null && _b !== void 0 ? _b : this.getFillColor();
    }
  }, {
    key: "isInsideCanvas",
    value: function isInsideCanvas() {
      var radius = this.getRadius(),
          canvasSize = this.container.canvas.size;
      return this.position.x >= -radius && this.position.y >= -radius && this.position.y <= canvasSize.height + radius && this.position.x <= canvasSize.width + radius;
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      return !this.destroyed && !this.spawning && this.isInsideCanvas();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.opacity) {
        this.opacity.loops = 0;
      }

      this.size.loops = 0;
    }
  }, {
    key: "calcPosition",
    value: function calcPosition(container, position, zIndex) {
      var tryCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      var _a, _b, _c, _d;

      var _iterator6 = _createForOfIteratorHelper(container.plugins),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              plugin = _step6$value[1];

          var pluginPos = plugin.particlePosition !== undefined ? plugin.particlePosition(position, this) : undefined;

          if (pluginPos !== undefined) {
            return Vector3d.create(pluginPos.x, pluginPos.y, zIndex);
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var canvasSize = container.canvas.size,
          exactPosition = calcExactPositionOrRandomFromSize({
        size: canvasSize,
        position: position
      }),
          pos = Vector3d.create(exactPosition.x, exactPosition.y, zIndex),
          radius = this.getRadius(),
          outModes = this.options.move.outModes,
          fixHorizontal = function fixHorizontal(outMode) {
        fixOutMode({
          outMode: outMode,
          checkModes: ["bounce", "bounce-horizontal"],
          coord: pos.x,
          maxCoord: container.canvas.size.width,
          setCb: function setCb(value) {
            return pos.x += value;
          },
          radius: radius
        });
      },
          fixVertical = function fixVertical(outMode) {
        fixOutMode({
          outMode: outMode,
          checkModes: ["bounce", "bounce-vertical"],
          coord: pos.y,
          maxCoord: container.canvas.size.height,
          setCb: function setCb(value) {
            return pos.y += value;
          },
          radius: radius
        });
      };

      fixHorizontal((_a = outModes.left) !== null && _a !== void 0 ? _a : outModes.default);
      fixHorizontal((_b = outModes.right) !== null && _b !== void 0 ? _b : outModes.default);
      fixVertical((_c = outModes.top) !== null && _c !== void 0 ? _c : outModes.default);
      fixVertical((_d = outModes.bottom) !== null && _d !== void 0 ? _d : outModes.default);

      if (this.checkOverlap(pos, tryCount)) {
        return this.calcPosition(container, undefined, zIndex, tryCount + 1);
      }

      return pos;
    }
  }, {
    key: "calculateVelocity",
    value: function calculateVelocity() {
      var baseVelocity = getParticleBaseVelocity(this.direction);
      var res = baseVelocity.copy();
      var moveOptions = this.options.move;

      if (moveOptions.direction === "inside" || moveOptions.direction === "outside") {
        return res;
      }

      var rad = Math.PI / 180 * getRangeValue(moveOptions.angle.value);
      var radOffset = Math.PI / 180 * getRangeValue(moveOptions.angle.offset);
      var range = {
        left: radOffset - rad / 2,
        right: radOffset + rad / 2
      };

      if (!moveOptions.straight) {
        res.angle += randomInRange(setRangeValue(range.left, range.right));
      }

      if (moveOptions.random && typeof moveOptions.speed === "number") {
        res.length *= Math.random();
      }

      return res;
    }
  }, {
    key: "checkOverlap",
    value: function checkOverlap(pos) {
      var tryCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var collisionsOptions = this.options.collisions,
          radius = this.getRadius();

      if (!collisionsOptions.enable) {
        return false;
      }

      var overlapOptions = collisionsOptions.overlap;

      if (overlapOptions.enable) {
        return false;
      }

      var retries = overlapOptions.retries;

      if (retries >= 0 && tryCount > retries) {
        throw new Error("Particle is overlapping and can't be placed");
      }

      var overlaps = false;

      var _iterator7 = _createForOfIteratorHelper(this.container.particles.array),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var particle = _step7.value;

          if (getDistance(pos, particle.position) < radius + particle.getRadius()) {
            overlaps = true;
            break;
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      return overlaps;
    }
  }, {
    key: "loadShapeData",
    value: function loadShapeData(shapeOptions, reduceDuplicates) {
      var shapeData = shapeOptions.options[this.shape];

      if (shapeData) {
        return deepExtend({}, shapeData instanceof Array ? itemFromArray(shapeData, this.id, reduceDuplicates) : shapeData);
      }
    }
  }, {
    key: "split",
    value: function split() {
      var splitOptions = this.options.destroy.split;

      if (splitOptions.count >= 0 && this.splitCount++ > splitOptions.count) {
        return;
      }

      var rate = getValue(splitOptions.rate),
          particlesSplitOptions = splitOptions.particles instanceof Array ? itemFromArray(splitOptions.particles) : splitOptions.particles;

      for (var i = 0; i < rate; i++) {
        this.container.particles.addSplitParticle(this, particlesSplitOptions);
      }
    }
  }]);

  return Particle;
}();
_Particle_engine = new WeakMap();